// Classic deferred scripts preserve library -> initialization -> theme consumers.
(() => {
  const release = () => document.documentElement.removeAttribute('data-yl-language-pending');
  const provider = window.Weglot;
  const settings = document.currentScript?.dataset;
  if (!provider || !settings?.apiKey) { release(); return; }
  if (provider.initialized) { release(); return; }
  provider.on('initialized', language => {
    // The provider initializes before its asynchronous translation finishes.
    const current = language || provider.getCurrentLang();
    if (current === provider.options.language_from) release();
  });
  provider.on('languageChanged', release);
  const options = { api_key: settings.apiKey };
  if (settings.customSwitcher === 'true') options.hide_switcher = true;
  try { provider.initialize(options); }
  catch { release(); }
})();
